import { addStyles } from '../../utils/helpers';
import { Tag } from '../tag/tag';
import { TagProps } from '../tag/tag.types';

export const TableTag = (props: TagProps) => {
  return (
    <Tag
      {...{
        ...props,
        baseType: 'table',
        className: addStyles([
          props.className,
          'table-tag mr-1 normal-case border-0 flex border rounded-sm py-1 px-2 text-xs font-medium text-gray-900',
        ]),
      }}
    />
  );
};
export default TableTag;
